import React from 'react';
import { DownloadIcon } from '../icons';

const maxFileChar = 40;

const FileName = ({ fileName, onDownload }) => {
    // Check if the filename needs truncation
    const isLong = fileName?.length > maxFileChar;
    const displayName = isLong ? fileName?.slice(0, maxFileChar) + '...' : fileName;
    return (
        <div className="grid grid-cols-[1fr_auto] items-center w-full  max-w-md gap-x-2  py-2 rounded bg-white">
            <div className="text-primaryColor font-semibold ">{displayName}</div>
            <button
                onClick={onDownload}
                className="text-primaryColor hover:text-primaryColor"
                aria-label="Download"
            >
                <DownloadIcon className="w-5 h-5" />
            </button>
        </div>
    );
};
export default FileName;
